import { io } from "socket.io-client";

// Get the base URL from the API URL, removing the '/api' part
const BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");

export const socket = io(BASE_URL, {
  path: "/socket.io/",
  cors: {
    origin: BASE_URL,
  },
  auth: {
    strategy: "apiToken",
    token: process.env.REACT_APP_API_KEY,
  },
  transports: ["websocket", "polling"],
});

// Add error handling
socket.on("connect_error", (error) => {
  console.error("Socket connection error:", error);
});

socket.on("connect", () => {
  console.log("Socket connected successfully");
});
